"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var Media_1 = require("./Media");
var FragmentMeta_1 = require("../content/model/FragmentMeta");
var ImageUrlBuilder_1 = require("./ImageUrlBuilder");
var MediaMeta_1 = require("./MediaMeta");
/**
 * Class representing a Video resource with helper functions.s
 */
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    /**
     * Creates a new Video instance.
     * @param data JSON data from delivery API
     */
    function Video(data, config) {
        var _this = _super.call(this, data, config) || this;
        if (data && data._meta) {
            _this._meta = new MediaMeta_1.VideoMeta(data._meta);
        }
        return _this;
    }
    /**
     * Returns a builder which can be used to construct a video thumbnail URL.
     * You can apply transformations such as resize and image format using the returned builder.
     *
     * ```typescript
     * video.thumbnail().width(500).build();
     * ```
     */
    Video.prototype.thumbnail = function () {
        return new ImageUrlBuilder_1.ImageUrlBuilder(this);
    };
    /**
     * Export Video to JSON
     */
    Video.prototype.toJSON = function () {
        var result = _super.prototype.toJSON.call(this);
        if (this._meta) {
            result._meta = this._meta.toJSON();
        }
        return result;
    };
    /**
     * @hidden
     * Returns true if the provided fragment is a video
     * @param fragment
     */
    Video.isVideo = function (fragment) {
        return (FragmentMeta_1.FragmentMeta.isFragment(fragment) &&
            fragment._meta.schema ===
                'http://bigcontent.io/cms/schema/v1/core#/definitions/video-link');
    };
    return Video;
}(Media_1.Media));
exports.Video = Video;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlkZW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21lZGlhL1ZpZGVvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGlDQUFnQztBQUNoQyw4REFBNkQ7QUFDN0QscURBQW9EO0FBRXBELHlDQUF3QztBQUV4Qzs7R0FFRztBQUNIO0lBQTJCLHlCQUFLO0lBTTlCOzs7T0FHRztJQUNILGVBQVksSUFBUyxFQUFFLE1BQWlDO1FBQXhELFlBQ0Usa0JBQU0sSUFBSSxFQUFFLE1BQU0sQ0FBQyxTQUlwQjtRQUhDLElBQUksSUFBSSxJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDdEIsS0FBSSxDQUFDLEtBQUssR0FBRyxJQUFJLHFCQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ3hDOztJQUNILENBQUM7SUFFRDs7Ozs7OztPQU9HO0lBQ0gseUJBQVMsR0FBVDtRQUNFLE9BQU8sSUFBSSxpQ0FBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ25DLENBQUM7SUFFRDs7T0FFRztJQUNILHNCQUFNLEdBQU47UUFDRSxJQUFNLE1BQU0sR0FBRyxpQkFBTSxNQUFNLFdBQUUsQ0FBQztRQUM5QixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDZCxNQUFNLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDcEM7UUFDRCxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNXLGFBQU8sR0FBckIsVUFBc0IsUUFBYTtRQUNqQyxPQUFPLENBQ0wsMkJBQVksQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDO1lBQ2pDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTTtnQkFDbkIsaUVBQWlFLENBQ3BFLENBQUM7SUFDSixDQUFDO0lBQ0gsWUFBQztBQUFELENBQUMsQUFwREQsQ0FBMkIsYUFBSyxHQW9EL0I7QUFwRFksc0JBQUsifQ==